import React from "react";

export default function HelpPdfQuote() {
  return (
    <div className="help__block">
      <i className="help__icon icon-print" />
      <div className="help__subject help__subject--pdf">
        <b>Need a PDF quote?</b>
        <p className="help__small">
          You can generate one instantly by following the steps below!
        </p>
      </div>
      <div className="help__list">
        <ol>
          <li>Log into your registered account or register on the site.</li>
          <li>
            Add all of the items you want to be listed on the quote to your
            cart.
          </li>
          <li>
            Enter &quot;Quote&quot; in the coupon code box on the lower right
            side of your cart.
          </li>
          <li>
            Receive the PDF quote of the items in your cart at your registered
            email address.
          </li>
        </ol>
      </div>
    </div>
  );
}
